var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7168 11.7463C19.7168 10.6213 18.8177 10.1307 18.102 9.74058C17.6253 9.47952 17.2293 9.26392 17.2367 8.93392C17.2367 8.67065 17.4713 8.40812 17.9964 8.33258C18.6001 8.27462 19.2081 8.38531 19.7527 8.65232L20.0607 7.15192C19.5309 6.94079 18.9657 6.83253 18.3953 6.83292C16.639 6.83292 15.407 7.80825 15.3887 9.17738C15.3711 10.2085 16.276 10.7709 16.9463 11.1083C17.6165 11.4456 17.8703 11.6898 17.8703 11.9897C17.8703 12.4591 17.3085 12.6842 16.8018 12.6842C16.1627 12.7019 15.5307 12.5463 14.9729 12.2339L14.6465 13.7901C15.2714 14.0507 15.9437 14.1788 16.6207 14.1663C18.4855 14.1846 19.6985 13.2283 19.7168 11.7463ZM12.3468 6.96418L9.46847 14.0717H7.58527L6.17287 8.38978C6.08193 8.03338 6.01007 7.92045 5.75633 7.77085C5.20029 7.49322 4.60961 7.29123 4 7.17025L4.03667 6.96418H7.0602C7.2611 6.96789 7.45394 7.04382 7.60342 7.17809C7.7529 7.31236 7.84903 7.49597 7.8742 7.69532L8.61707 11.802L10.4643 6.96492H12.3475L12.3468 6.96418ZM26 14.0717H24.3522L24.1175 13.0025H21.8347L21.4724 14.0717H19.6075L22.2879 7.48925C22.4125 7.16878 22.7147 6.95978 23.0483 6.96418H24.5693L26 14.0717ZM22.3605 11.5585L23.3021 8.89578L23.8447 11.5585H22.3605ZM13.416 14.0717L14.8827 6.96418H13.108L11.6413 14.0717H13.416Z",
    fill: "#1A1F71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0f161aea.svg";
export { ForwardRef as ReactComponent };